import { FC } from "react";
import { iDataUserSuscription } from "../../../../interfaces/SuperAdmin/Pages/iDataUserSuscription";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";

interface Props {
  usuario: iDataUserSuscription;
  i: number;
}

const ProfileRowCreditsSuscription: FC<Props> = ({ usuario, i }) => {
  const { nombres, apellidos, fecha_asignacion, creditos_gastados, estado } =
    usuario;
  return (
    <StyledTableRow>
      <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {nombres}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {apellidos}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {new Date(fecha_asignacion).toLocaleString()}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {creditos_gastados}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {estado}
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default ProfileRowCreditsSuscription;
